export default __webpack_public_path__ + "locales/fi/FilesSettings.json?hash=6fc459ec1c28210cebd53a2634ea264f";